import './BackMenuButton.scss';

import cn from 'classnames';
import React from 'react';

import Button from '@/common/components/atoms/Button/Button';
import { ReactComponent as BackIcon } from '@/ebat/assets/icons/chevron-left.svg';

import {
  BackMenuButtonDefaultProps,
  BackMenuButtonPropTypes,
} from './BackMenuButton.proptypes';

const BackMenuButton = ({ className, label, onClick }) => (
  <Button
    className={cn(className, 'back-menu-button')}
    context="back-menu-button"
    onClick={onClick}
  >
    <BackIcon className="back-menu-button__icon" />
    <span className="back-menu-button__label">{label}</span>
  </Button>
);

BackMenuButton.defaultProps = {
  ...BackMenuButtonDefaultProps,
};

BackMenuButton.propTypes = {
  ...BackMenuButtonPropTypes,
};

export default BackMenuButton;
